<template>
	<div
		v-bind:class="[
			{
				'builder-element': !onPreview,
				'hide-desktop': node.options.visible_desktop,
				'hide-mobile': node.options.visible_mobile,
			},
			node.class,
		]"
		:id="node.id"
		:data-key="node.key"
		:data-elIcon="node.icon"
		:data-elName="node.name"
		:data-type="node.type"
		@click="onNodeClick(node)"
		:style="getWrapperStyle(node)"
	>
		<NodeAction :node="node" component="element" v-if="!onPreview" />

		<!-- v-if="node.options.type == 'ul'" -->
		<div :style="getMainStyle(node)">
			<ul
				class="node-list"
				:class="node.class"
				:id="node.id"
				:style="getStyle(node)">
				<template v-if="node.options && node.options.items">
					<li
						v-for="(child, i) in node.options.items"
						:key="i"
						:style="getItemStyle(node)">
						<i
							:style="getIconStyle(node)"
							:class="getIconClass(child)" />
						<span class="ml-1">
							<!-- {{ child.content }} -->
							<NodeEditor
								:key="`${node.key}-${i}`"
								v-model="child.content"
								@focus="onNodeClick(node)"
							/>
						</span>
					</li>
				</template>
			</ul>
		</div>
	</div>
</template>

<script>
import { mapActions } from 'vuex';
import NodeAction from '@/components/funnels/pagebuilder/nodes/NodeAction.vue';
// eslint-disable-next-line
import NodeEditor from '@/components/funnels/pagebuilder/nodes/NodeEditor.vue';
import {
	// eslint-disable-next-line
	getIconStyle,
	getRgbaColor,
	getNodeStyle,
	getIcon,
// eslint-disable-next-line
} from '@/lib/helper';

export default {
	name: 'NodeList',
	props: ['node', 'onPreview', 'previewDevice'],
	components: {
		NodeAction,
		NodeEditor,
	},
	methods: {
		...mapActions({
			setActionElement: 'funnels/setActionElement',
		}),
		getMainStyle({ options }) {
			const style = {};
			let contentAlign = 'flex-start';
			style.display = 'flex';

			if (options) {
				const { align } = options;
				if (align === 'center') {
					contentAlign = 'center';
				} else if (align === 'right') {
					contentAlign = 'flex-end';
				}
			}
			style['justify-content'] = contentAlign;
			return style;
		},

		getStyle({ options }) {
			const device = this.previewDevice;
			const styles = [
				'text-color',
				'font-family',
				'font-weight',
				'font-size',
				'font-style',
				'text-decoration',
			];
			const style = getNodeStyle(options, styles, device);
			return style;
		},

		getWrapperStyle({ options }) {
			const device = this.previewDevice;
			const styles = [
				'margin',
			];
			const style = getNodeStyle(options, styles, device);
			return style;
		},

		getItemStyle({ options }) {
			const style = {};

			if (options) {
				const { spaceBetween } = options;
				style['padding-bottom'] = `calc(${spaceBetween}px/2)`;
			}
			return style;
		},

		getIconStyle({ options }) {
			const style = {};

			if (options) {
				const device = this.previewDevice;

				style.color = options.iconColor && options.iconColor.rgb && options.iconColor.rgb !== ''
					? getRgbaColor(options.iconColor.rgb)
					: options.iconColor;

				if (device === 'desktop') {
					const fixedIconSizeUnit = options.iconSizeUnit && options.iconSizeUnit !== '' ? options.iconSizeUnit : 'px';
					style['font-size'] = options.iconSize && options.iconSize !== ''
						? `${options.iconSize}${fixedIconSizeUnit}`
						: '16px';
				} else if (device === 'mobile') {
					const fixedMobileIconSizeUnit = options.mobileIconSizeUnit && options.mobileIconSizeUnit !== '' ? options.mobileIconSizeUnit : 'px';
					style['font-size'] = options.mobileIconSize && options.mobileIconSize !== ''
						? `${options.mobileIconSize}${fixedMobileIconSizeUnit}`
						: '16px';
				}
			}
			return style;
		},

		getIconClass(item) {
			return getIcon(item.iconKey, item.iconStyle);
		},
		onNodeClick(node) {
			this.handleAction('edit', node);
		},
		handleAction(type, node) {
			this.$bus.$emit('action-element', type, node);
			// this.setActionElement({ type, node });
		},
	},
};
</script>

<style lang="scss">
.node-list {
	list-style-type: none;
	padding-left: 0;
	margin-bottom: 0;

	li {
		display: flex;
		align-items: center;

		i {
			width: 1.25em;
		}

		span {
			flex: 1;
		}
	}

	.ProseMirror {
		p {
			margin-bottom: 0;
		}
	}

	.inline-editor {
		.ProseMirror-focused {
			border: 1px solid rgb(29, 29, 29) !important;
		}
	}
}
</style>
